module.exports = __webpack_public_path__ + "img/icon-sign.e3b2421c.png";